'use client'

import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Box, Checkbox, Text } from '@chakra-ui/react'
import type { Control, FieldErrors } from 'react-hook-form'
import type { SurveyFormValues } from '../model/use-medical-survey-form'

interface Props {
  control: Control<SurveyFormValues>
  errors: FieldErrors<SurveyFormValues>
  disabled?: boolean
}

/** The "no alcohol / no aspirin" confirmation the doctor has to tick to save. */
export function SurveyConfirmation({ control, errors, disabled }: Props) {
  const { t } = useTranslation()
  const error = (errors as Record<string, { message?: string } | undefined>)
    .confirmed

  return (
    <Box
      bg="badge.red.20"
      borderWidth="1px"
      borderColor="badge.red.100"
      borderRadius="xl"
      p={4}
    >
      <Controller
        control={control}
        name="confirmed"
        rules={{
          validate: (value) =>
            value === true ||
            t('donor_detail.medical_survey.validation.confirm_required'),
        }}
        render={({ field }) => (
          <Checkbox.Root
            checked={!!field.value}
            onCheckedChange={(e) => field.onChange(e.checked)}
            disabled={disabled}
            colorPalette="red"
            alignItems="flex-start"
          >
            <Checkbox.HiddenInput />
            <Checkbox.Control borderColor="red.500" cursor="pointer" mt={0.5} />
            <Checkbox.Label fontSize="sm" lineHeight={1.5}>
              {t('donor_detail.medical_survey.confirm_text')}
            </Checkbox.Label>
          </Checkbox.Root>
        )}
      />
      {Boolean(error) && (
        <Text color="red.500" fontSize="xs" mt={2}>
          {String(error?.message ?? '')}
        </Text>
      )}
    </Box>
  )
}
